import React, { useState } from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import type { MessageActionContentRenderer } from '@atlassian/conversation-assistant-message-actions-api/types';

import { CardFooter } from './card-footer';
import { CardHeader } from './card-header';

const containerStyles = cssMap({
	card: {
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		borderRadius: token('radius.xlarge'),
		overflow: 'hidden',
	},
});

const styles = cssMap({
	contentWrapper: {
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		borderTopWidth: token('border.width'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
	},
});

type AutomationCreateRuleCardProps = {
	ruleName: string;
	overview: string;
	ContentRenderer: MessageActionContentRenderer;
	onConfirm: () => Promise<void>;
	isDisabled: boolean;
	isSubmitting: boolean;
	productKey?: string;
	siteId?: string;
};

export const AutomationCreateRuleCard = ({
	ruleName,
	overview,
	ContentRenderer,
	onConfirm,
	isDisabled,
	isSubmitting,
	productKey,
	siteId,
}: AutomationCreateRuleCardProps): React.JSX.Element => {
	const [isOpen, setIsOpen] = useState(true);

	return (
		<Box xcss={containerStyles.card} testId="studio-automation-create-rule-card">
			<CardHeader ruleName={ruleName} isOpen={isOpen} onToggle={() => setIsOpen(!isOpen)} />
			{isOpen && (
				<>
					<Box xcss={styles.contentWrapper}>
						<Stack space="space.100">
							<ContentRenderer
								content={overview}
								productKey={productKey ?? ''}
								siteId={siteId ?? ''}
							/>
						</Stack>
					</Box>
					<CardFooter onConfirm={onConfirm} isDisabled={isDisabled} isSubmitting={isSubmitting} />
				</>
			)}
		</Box>
	);
};
